import {
  AddressDetailIcon,
  BasicDetailIcon,
  ContactDetailIcon,
  JobDetailIcon,
  PersonalDetailIcon,
} from "../../assets/images";
import { UserProfileType } from "../../redux/auth/authTypes";
import { formatDate } from "../../utils/commonFunctions";
import CustomizedAvatar from "../commons/CircularAvatar/CustomizedAvatar";
import "./TeamDetails.scss";
type AppProps = {
  userProfileAllData: any;
};
const TeamDetails = ({ userProfileAllData }: AppProps) => {
  return (
    <div>
      <div
        className="row ml-3 d-flex flex-column mb-2 mt-4"
        style={{
          width: "93%",
        }}
      >
        <div
          className=""
          style={{
            display: "flex",
            gap: "10px",
            marginLeft: "5px",
            marginBottom: "22px",
            alignItems:'center'
          }}
        >
          <div>
            <CustomizedAvatar
              name={`${userProfileAllData?.user_details?.basic_details?.first_name} ${userProfileAllData?.user_details?.basic_details?.last_name}`}
              image={
                userProfileAllData?.user_details?.profile_pic &&
                userProfileAllData?.user_details?.profile_pic?.file_url
              }
              style={{ width: "80px", fontSize: "20px" }}
            />
          </div>
          <div>
            <span
              style={{
                fontSize: "16px",
                color: "#262a44",
                lineHeight: "16px",
                fontWeight: "500",
                marginBottom: "5px",
                display: "inline-block",
              }}
            >
              {`${userProfileAllData?.user_details?.basic_details?.first_name} ${userProfileAllData?.user_details?.basic_details?.last_name}`}
            </span>

            <p style={{ fontSize: "13px", color: "#6e7491", margin: "0px" }}>
              {userProfileAllData?.user_details?.basic_details?.email_id}
              {userProfileAllData?.user_details?.contact_details?.mobile
                ? ` | ${userProfileAllData?.user_details?.contact_details?.mobile}`
                : ""}
            </p>
          </div>
        </div>
        <div className="mb-3 teamDetailOuterContainer">
          <div className="d-flex align-item-center mb-0">
            <img
              src={PersonalDetailIcon}
              width="32px"
              height="32px"
              style={{ marginLeft: "21px", marginTop: "18px" }}
            />{" "}
            <p className="ml-2 headingTeamParagraph">Basic Details</p>
          </div>

          <div className="row ml-1 col-md-12 mt-1">
            <div className="col-md-4 p-1">
              <label className="mb-1 subHeadingTeamDetailLabel" htmlFor="Stage">
                Date of Birth
              </label>
              <p>
                {userProfileAllData?.user_details?.personal_details
                  ?.date_of_birth
                  ? formatDate(
                      userProfileAllData?.user_details?.personal_details
                        ?.date_of_birth
                    )
                  : "NA"}
              </p>
            </div>
            <div className="col-md-4 pt-1 pb-1">
              <label
                className="mb-1 subHeadingTeamDetailLabel"
                htmlFor="Response"
              >
                Gender
              </label>
              <p>
                {userProfileAllData?.user_details?.personal_details?.gender
                  ? userProfileAllData?.user_details?.personal_details?.gender
                  : "NA"}
              </p>
            </div>
            <div className="col-md-4 pt-1 pb-1">
              <label
                className="mb-1 subHeadingTeamDetailLabel"
                htmlFor="Response"
              >
                Blood Group
              </label>
              <p>
                {userProfileAllData?.user_details?.personal_details?.blood_group
                  ? userProfileAllData?.user_details?.personal_details
                      ?.blood_group
                  : "NA"}
              </p>
            </div>
          </div>
          <div className="row ml-1 col-md-12">
            <div className="col-md-4 p-1">
              <label
                className="mb-1 subHeadingTeamDetailLabel"
                htmlFor="Response"
              >
                Qualifications
              </label>
              <p>
                {userProfileAllData?.user_details?.personal_details
                  ?.qualifications
                  ? userProfileAllData?.user_details?.personal_details
                      ?.qualifications
                  : "NA"}
              </p>
            </div>
            <div className="col-md-4 pt-1 pb-1">
              <label className="mb-1 subHeadingTeamDetailLabel" htmlFor="Stage">
                Mother Name
              </label>
              <p>
                {userProfileAllData?.user_details?.personal_details?.mother_name
                  ? userProfileAllData?.user_details?.personal_details
                      ?.mother_name
                  : "NA"}
              </p>
            </div>

            <div className="col-md-4 pt-1 pb-1">
              <label className="mb-1 subHeadingTeamDetailLabel" htmlFor="Stage">
                Marital Status
              </label>
              <p>
                {userProfileAllData?.user_details?.personal_details
                  ?.martial_status
                  ? userProfileAllData?.user_details?.personal_details
                      ?.martial_status
                  : "NA"}
              </p>
            </div>
          </div>
          <div className="row ml-1 col-md-12">
            <div className="col-md-4 p-1">
              <label className="mb-1 subHeadingTeamDetailLabel" htmlFor="Stage">
                Spouse Name
              </label>
              <p>
                {userProfileAllData?.user_details?.personal_details?.spouse_name
                  ? userProfileAllData?.user_details?.personal_details
                      ?.spouse_name
                  : "NA"}
              </p>
            </div>
            <div className="col-md-4 pt-1 pb-1">
              <label className="mb-1 subHeadingTeamDetailLabel" htmlFor="Stage">
                Father/Husband Name
              </label>
              <p>
                {userProfileAllData?.user_details?.personal_details
                  ?.father_or_husband_name
                  ? userProfileAllData?.user_details?.personal_details
                      ?.father_or_husband_name
                  : "NA"}
              </p>
            </div>
            <div className="col-md-4 pt-1 pb-1">
              <label className="mb-1 subHeadingTeamDetailLabel" htmlFor="Stage">
                About Me
              </label>
              <p style={{ overflowWrap: "anywhere" }}>
                {userProfileAllData?.user_details?.personal_details?.about_me
                  ? userProfileAllData?.user_details?.personal_details?.about_me
                  : "NA"}
              </p>
            </div>
          </div>
          <div className="row ml-1 col-md-12">
            <div className="col-md-4 p-1">
              <label className="mb-1 subHeadingTeamDetailLabel" htmlFor="Stage">
                Linkedin Profile
              </label>
              <p style={{ wordWrap: "break-word" }}>
                {userProfileAllData?.user_details?.online_presence
                  ?.linkedin_profile
                  ? userProfileAllData?.user_details?.online_presence
                      ?.linkedin_profile
                  : "NA"}
              </p>
            </div>
            <div className="col-md-4 pt-1 pb-1">
              <label className="mb-1 subHeadingTeamDetailLabel" htmlFor="Stage">
                Twitter ID
              </label>
              <p style={{ overflowWrap: "anywhere" }}>
                {userProfileAllData?.user_details?.online_presence?.twitter_id
                  ? userProfileAllData?.user_details?.online_presence
                      ?.twitter_id
                  : "NA"}
              </p>
            </div>
            <div className="col-md-4 pt-1 pb-1">
              <label className="mb-1 subHeadingTeamDetailLabel" htmlFor="Stage">
                Skills
              </label>
              <p style={{ overflowWrap: "anywhere" }}>
              {userProfileAllData?.user_details?.basic_details?.skill?.length>0
  ? userProfileAllData?.user_details.basic_details?.skill?.map((element: any) => {
        return(
          <>
          <div className="mt-1" style={{marginBottom:'14px'}}>
            <span className="skillBadge"> {element.skill_name
            }</span>
          </div>
          </>
        );
      })
  : "NA"}
              </p>
            </div>
          </div>
        </div>

        <div className="mb-3 teamDetailOuterContainer">
          <div className="d-flex align-item-center mb-0">
            <img
              src={AddressDetailIcon}
              width="32px"
              height="32px"
              style={{ marginLeft: "21px", marginTop: "18px" }}
            />{" "}
            <p className="ml-2 headingTeamParagraph">Current Address Details</p>
          </div>
          <div className="row ml-1 col-md-12 mt-1">
            <div className="col-md-6 p-1">
              <label
                className="mb-1 subHeadingTeamDetailLabel"
                htmlFor="Response"
              >
                Address Line 1
              </label>
              <p>
                {userProfileAllData?.user_details?.current_address
                  ?.address_line1
                  ? userProfileAllData?.user_details?.current_address
                      ?.address_line1
                  : "NA"}
              </p>
            </div>
            <div className="col-md-6 pt-1 pb-1">
              <label className="mb-1 subHeadingTeamDetailLabel" htmlFor="Stage">
                Address Line 2
              </label>
              <p>
                {userProfileAllData?.user_details?.current_address
                  ?.address_line2
                  ? userProfileAllData?.user_details?.current_address
                      ?.address_line2
                  : "NA"}
              </p>
            </div>
          </div>
          <div className="row ml-1 col-md-12">
            <div className="col-md-3 p-1">
              <label className="mb-1 subHeadingTeamDetailLabel" htmlFor="Stage">
                Postal Code
              </label>
              <p>
                {userProfileAllData?.user_details?.current_address?.postal_code
                  ? userProfileAllData?.user_details?.current_address
                      ?.postal_code
                  : "NA"}
              </p>
            </div>
            <div className="col-md-3 pb-1 pt-1">
              <label
                className="mb-1 subHeadingTeamDetailLabel"
                htmlFor="Response"
              >
                Country
              </label>
              <p>
                {userProfileAllData?.user_details?.current_address?.country
                  ?.label &&
                userProfileAllData?.user_details?.current_address?.country
                  ?.label !== "Select"
                  ? userProfileAllData.user_details.current_address.country
                      .label
                  : "NA"}
              </p>
            </div>
            <div className="col-md-3 pt-1 pb-1">
              <label className="mb-1 subHeadingTeamDetailLabel" htmlFor="Stage">
                State{" "}
              </label>
              <p>
                {userProfileAllData?.user_details?.current_address?.state
                  ?.label &&
                userProfileAllData?.user_details?.current_address?.state
                  ?.label !== "Select"
                  ? userProfileAllData?.user_details?.current_address?.state
                      ?.label
                  : "NA"}
              </p>
            </div>
            <div className="col-md-3 pt-1 pb-1">
              <label className="mb-1 subHeadingTeamDetailLabel" htmlFor="Stage">
                City
              </label>
              <p>
                {userProfileAllData?.user_details?.current_address?.city
                  ?.label &&
                userProfileAllData?.user_details?.current_address?.city
                  ?.label !== "Select"
                  ? userProfileAllData?.user_details?.current_address?.city
                      ?.label
                  : "NA"}
              </p>
            </div>
          </div>
        </div>
        <div className="mb-3 teamDetailOuterContainer">
          <div className="d-flex align-item-center mb-0">
            <img
              src={AddressDetailIcon}
              width="32px"
              height="32px"
              style={{ marginLeft: "21px", marginTop: "18px" }}
            />{" "}
            <p className="ml-2 headingTeamParagraph">
              Permanent Address Details
            </p>
          </div>
          <div className="row ml-1 col-md-12 mt-1">
            <div className="col-md-6 p-1">
              <label
                className="mb-1 subHeadingTeamDetailLabel"
                htmlFor="Response"
              >
                Address Line 1
              </label>
              <p>
                {userProfileAllData?.user_details?.permanent_address
                  ?.address_line1
                  ? userProfileAllData?.user_details?.permanent_address
                      ?.address_line1
                  : "NA"}
              </p>
            </div>
            <div className="col-md-6 pt-1 pb-1">
              <label className="mb-1 subHeadingTeamDetailLabel" htmlFor="Stage">
                Address Line 2
              </label>
              <p>
                {userProfileAllData?.user_details?.permanent_address
                  ?.address_line2
                  ? userProfileAllData?.user_details?.permanent_address
                      ?.address_line2
                  : "NA"}
              </p>
            </div>
          </div>
          <div className="row ml-1 col-md-12">
            <div className="col-md-3 p-1">
              <label className="mb-1 subHeadingTeamDetailLabel" htmlFor="Stage">
                Postal Code
              </label>
              <p>
                {userProfileAllData?.user_details?.permanent_address
                  ?.postal_code
                  ? userProfileAllData?.user_details?.permanent_address
                      ?.postal_code
                  : "NA"}
              </p>
            </div>
            <div className="col-md-3 pb-1 pt-1">
              <label
                className="mb-1 subHeadingTeamDetailLabel"
                htmlFor="Response"
              >
                Country
              </label>
              <p>
                {userProfileAllData?.user_details?.permanent_address?.country
                  ?.label &&
                userProfileAllData?.user_details?.permanent_address?.country
                  ?.label !== "Select"
                  ? userProfileAllData.user_details.permanent_address.country
                      .label
                  : "NA"}
              </p>
            </div>
            <div className="col-md-3 pt-1 pb-1">
              <label className="mb-1 subHeadingTeamDetailLabel" htmlFor="Stage">
                State{" "}
              </label>
              <p>
                {userProfileAllData?.user_details?.permanent_address?.state
                  ?.label &&
                userProfileAllData?.user_details?.permanent_address?.state
                  ?.label !== "Select"
                  ? userProfileAllData?.user_details?.permanent_address?.state
                      ?.label
                  : "NA"}
              </p>
            </div>
            <div className="col-md-3 pt-1 pb-1">
              <label className="mb-1 subHeadingTeamDetailLabel" htmlFor="Stage">
                City
              </label>
              <p>
                {userProfileAllData?.user_details?.permanent_address?.city
                  ?.label &&
                userProfileAllData?.user_details?.permanent_address?.city
                  ?.label !== "Select"
                  ? userProfileAllData?.user_details?.permanent_address?.city
                      ?.label
                  : "NA"}
              </p>
            </div>
          </div>
        </div>
        <div className="mb-3 teamDetailOuterContainer">
          <div className="d-flex align-item-center mb-0">
            <img
              src={ContactDetailIcon}
              width="32px"
              height="32px"
              style={{ marginLeft: "21px", marginTop: "18px" }}
            />{" "}
            <p className="ml-2 headingTeamParagraph">Communication Details</p>
          </div>
          <div className="row ml-1 col-md-12 mt-1">
            <div className="col-md-4 p-1">
              <label className="mb-1 subHeadingTeamDetailLabel" htmlFor="Stage">
                Personal Email ID
              </label>
              <p style={{ overflowWrap: "anywhere" }}>
                {userProfileAllData?.user_details?.contact_details
                  ?.personal_email_id
                  ? userProfileAllData?.user_details?.contact_details
                      ?.personal_email_id
                  : "NA"}
              </p>
            </div>
            <div className="col-md-4 pt-1 pb-1">
              <label
                className="mb-1 subHeadingTeamDetailLabel"
                htmlFor="Response"
              >
                Mobile
              </label>
              <p>
                {userProfileAllData?.user_details?.contact_details?.mobile
                  ? userProfileAllData?.user_details?.contact_details?.mobile
                  : "NA"}
              </p>
            </div>
            <div className="col-md-4 pt-1 pb-1">
              <label
                className="mb-1 subHeadingTeamDetailLabel"
                htmlFor="Response"
              >
                Whatsapp Number
              </label>
              <p>
                {userProfileAllData?.user_details?.contact_details
                  ?.whatsapp_number
                  ? userProfileAllData?.user_details?.contact_details
                      ?.whatsapp_number
                  : "NA"}
              </p>
            </div>
          </div>
          <div className="row ml-1 col-md-12">
            <div className="col-md-4 p-1">
              <label className="mb-1 subHeadingTeamDetailLabel" htmlFor="Stage">
                Work Phone
              </label>
              <p>
                {userProfileAllData?.user_details?.contact_details?.work_phone
                  ? userProfileAllData?.user_details?.contact_details
                      ?.work_phone
                  : "NA"}
              </p>
            </div>
            <div className="col-md-4 pt-1 pb-1">
              <label className="mb-1 subHeadingTeamDetailLabel" htmlFor="Stage">
                Emergency Contact Person
              </label>
              <p>
                {userProfileAllData?.user_details?.contact_details
                  ?.emergency_contact_person
                  ? userProfileAllData?.user_details?.contact_details
                      ?.emergency_contact_person
                  : "NA"}
              </p>
            </div>
            <div className="col-md-4 pt-1 pb-1">
              <label
                className="mb-1 subHeadingTeamDetailLabel"
                htmlFor="Response"
              >
                Emergency Contact Number
              </label>
              <p>
                {userProfileAllData?.user_details?.contact_details
                  ?.emergency_contact_number
                  ? userProfileAllData?.user_details?.contact_details
                      ?.emergency_contact_number
                  : "NA"}
              </p>
            </div>
          </div>
        </div>

        {userProfileAllData?.job_details?.map((job: any, index: any) => {
          return (
            <>
              {job?.is_default == true ? (
                <div className="mb-3 teamDetailOuterContainer">
                  <div className="d-flex align-item-center mb-0">
                    <img
                      src={JobDetailIcon}
                      width="32px"
                      height="32px"
                      style={{ marginLeft: "21px", marginTop: "18px" }}
                    />
                    <p className="ml-2 headingTeamParagraph">
                      Job Details{" "}
                      {/* {`${index + 1 < 10 ? "0" + (index + 1) : index + 1}`} */}
                    </p>{" "}
                  </div>
                  <div className="row ml-1 col-md-12 mt-1">
                    <div className="col-md-3 p-1">
                      <label
                        className="mb-1 subHeadingTeamDetailLabel"
                        htmlFor="Response"
                      >
                        Employee ID
                      </label>
                      <p>
                        {job?.job_info?.employee_id
                          ? job?.job_info?.employee_id
                          : "NA"}
                      </p>
                    </div>
                    <div className="col-md-3 pt-1 pb-1">
                      <label
                        className="mb-1 subHeadingTeamDetailLabel"
                        htmlFor="Stage"
                      >
                        Job Title
                      </label>
                      <p>
                        {job?.job_info?.job_title
                          ? job?.job_info?.job_title
                          : "NA"}
                      </p>
                    </div>
                    <div className="col-md-3 pt-1 pb-1">
                      <label
                        className="mb-1 subHeadingTeamDetailLabel"
                        htmlFor="Stage"
                      >
                        Department
                      </label>
                      <p>
                        {job?.job_info?.department?.department_name
                          ? job?.job_info?.department?.department_name
                          : "NA"}
                      </p>
                    </div>
                    <div className="col-md-3 pb-1 pt-1">
                      <label
                        className="mb-1 subHeadingTeamDetailLabel"
                        htmlFor="Response"
                      >
                        Total Experience
                      </label>
                      <p>
                        {job?.job_info?.total_experience
                          ? job?.job_info?.total_experience
                          : "NA"}
                      </p>
                    </div>
                  </div>
                  <div className="row ml-1 col-md-12">
                    <div className="col-md-3 p-1">
                      <label
                        className="mb-1 subHeadingTeamDetailLabel"
                        htmlFor="Stage"
                      >
                        Start Date
                      </label>
                      <p>
                        {job?.job_info?.start_date
                          ? formatDate(job?.job_info?.start_date)
                          : "NA"}
                      </p>
                    </div>
                    <div className="col-md-3 pt-1 pb-1">
                      <label
                        className="mb-1 subHeadingTeamDetailLabel"
                        htmlFor="Stage"
                      >
                        Reporting Person
                      </label>
                      <p>
                        {`${
                          job?.reporting_details?.reporting_person?.first_name
                            ? job?.reporting_details?.reporting_person
                                ?.first_name
                            : "NA"
                        } ${
                          job?.reporting_details?.reporting_person?.last_name
                            ? job?.reporting_details?.reporting_person
                                ?.last_name
                            : ""
                        }`}
                      </p>
                    </div>
                    <div className="col-md-3 pt-1 pb-1">
                      <label
                        className="mb-1 subHeadingTeamDetailLabel"
                        htmlFor="Stage"
                      >
                        Coach
                      </label>
                      <p>
                        {`${
                          job?.reporting_details?.coach?.first_name
                            ? job?.reporting_details?.coach?.first_name
                            : "NA"
                        } ${
                          job?.reporting_details?.coach?.last_name
                            ? job?.reporting_details?.coach?.last_name
                            : ""
                        }`}
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </>
          );
        })}
      </div>
    </div>
  );
};

export default TeamDetails;
